import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, watch } from "vue";
import { deleteRonda } from "@/services/TorneosService";

//eslint-disable-next-line no-undef

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalEliminarRondaTorneo',
  props: {
    isVisible: { type: Boolean },
    idTorneo: {},
    idRonda: {}
  },
  emits: ["confirm", "cerrar", "error"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

//eslint-disable-next-line no-undef
const emit = __emit;

const isModalEliminarVisible = ref<boolean>(props.isVisible);
const isGenerating = ref<boolean>(false);

const cerrarModal = () => {
  emit("cerrar");
};

watch(
  () => props.isVisible,
  newVal => {
    isModalEliminarVisible.value = newVal;
  }
);

const confirmar = async () => {
  try {
    isGenerating.value = true;
    const response = await deleteRonda(props.idTorneo, props.idRonda);
    emit("confirm", response.data as string);
  } catch (err: any) {
    const mensaje = err.response?.data ?? "No se ha podido eliminar la ronda";
    emit("error", mensaje);
  } finally {
    isGenerating.value = false;
    cerrarModal();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_dialog, {
      modelValue: isModalEliminarVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isModalEliminarVisible).value = $event)),
      "max-width": "400"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createTextVNode("Eliminar ronda")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createTextVNode(" ¿Estás seguro que deseas eliminar la ronda " + _toDisplayString(_ctx.idRonda) + "? Esta acción eliminará todas las partidas de la ronda y no se puede deshacer. ", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  justify: "center",
                  class: "my-4 ga-5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      variant: "tonal",
                      color: "error",
                      onClick: confirmar,
                      large: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Eliminar ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      small: "",
                      variant: "tonal",
                      color: "secondary",
                      onClick: cerrarModal
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Cancelar ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: isGenerating.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isGenerating).value = $event)),
      "hide-overlay": "",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "progress-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_progress_circular, {
              indeterminate: "",
              color: "primary",
              size: "70"
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})